interface PostAuthRedirectOptions {
  cartCount: number;
  search: string;
  storedCart: string | null;
  fallback?: string;
}

function storedCartHasItems(storedCart: string | null) {
  if (!storedCart) return false;

  try {
    const parsed = JSON.parse(storedCart);
    return Array.isArray(parsed) && parsed.length > 0;
  } catch {
    return false;
  }
}

export function resolvePostAuthRedirect({
  cartCount,
  search,
  storedCart,
  fallback = "/mon-compte",
}: PostAuthRedirectOptions) {
  // Le stockage persistant sert de garde-fou si le CartProvider n'a pas encore
  // terminé son hydratation au moment où l'utilisateur valide le formulaire.
  const requestedPath = new URLSearchParams(search).get("redirect");
  if (requestedPath?.startsWith("/") && !requestedPath.startsWith("//") && !requestedPath.includes("\\")) {
    return requestedPath;
  }
  if (cartCount > 0 || storedCartHasItems(storedCart)) return "/checkout";
  return fallback;
}
